export const servicesGroups = [
  {
    title: "Build",
    items: [
      { label: "Website development", desc: "High-converting, fast sites" },
      { label: "Web & mobile apps", desc: "React Native, PWA, API-first" },
      { label: "ERP systems", desc: "Operations, inventory, finance" },
      { label: "Custom solutions", desc: "Integrations and bespoke tools" },
      { label: "AI automation & integrations", desc: "Agents, RPA, copilots" },
    ],
  },
  {
    title: "Design & Brand",
    items: [
      { label: "UI/UX design", desc: "Research-led, conversion-first" },
      { label: "Branding", desc: "Identity, guidelines, kits" },
      { label: "Graphic design", desc: "Marketing and product visuals" },
      { label: "Video creation & editing", desc: "Explainers, promos, ads" },
    ],
  },
  {
    title: "Growth",
    items: [
      { label: "SEO", desc: "Technical, content, authority" },
      { label: "Social media marketing & management", desc: "Paid + organic" },
      { label: "Statistics & reporting", desc: "Dashboards & KPIs" },
    ],
  },
  {
    title: "Support",
    items: [
      { label: "Support & training", desc: "Enablement for teams" },
      { label: "Maintenance", desc: "SLA, uptime, patches" },
    ],
  },
];

export const hostingGroups = [
  {
    title: "Managed / Unmanaged",
    items: [
      "Shared Hosting",
      "VPS",
      "VDS",
      "Dedicated Servers",
      "Cloud Hosting",
      "WordPress Hosting",
      "E-Commerce Hosting",
      "Reseller Hosting",
    ],
  },
  {
    title: "Panels & Services",
    items: ["cPanel", "DirectAdmin", "Email Relay", "Email Hosting", "Database Hosting"],
  },
  {
    title: "Security & Essentials",
    items: ["SSL Certificates", "Domain Registration", "CDN Integration", "DDoS Protection", "Spam Filtering"],
  },
  {
    title: "Scalability",
    items: ["IaaS", "Elastic Containers", "Scalable Hosting"],
  },
];

export const hostingFeatures = [
  { label: "High reliability & uptime" },
  { label: "Top-end performance" },
  { label: "Modern hardware" },
  { label: "Robust security" },
  { label: "Daily backups" },
  { label: "CDN integration" },
  { label: "Spam filtering" },
  { label: "DDoS protection" },
];

export const processSteps = [
  { title: "Discover", desc: "Goals, constraints, and success metrics" },
  { title: "Design", desc: "Flows, wireframes, visual identity" },
  { title: "Build", desc: "Agile sprints, QA, accessibility" },
  { title: "Launch", desc: "Handoff, monitoring, training" },
  { title: "Scale", desc: "SEO, CRO, automation, hosting" },
];

export const testimonials = [
  {
    name: "Hany Afkar",
    role: "CEO, PureFabric",
    quote:
      "SKYRISE built us a blazing-fast website paired with powerful reporting tools—helping our brand stand out and gain the recognition it truly deserves.",
  },
  {
    name: "Remy Sherlock",
    role: "Founder, FNation",
    quote:
      "Working with SKYRISE was a true blessing. They elevated our branding and built an online store that not only lets us take deposits and orders seamlessly, but also makes it effortless to add or edit products from our own dashboard.",
  },
];

export const faqs = [
  {
    q: "How fast can we start?",
    a: "Discovery typically begins within 3–5 business days after kickoff.",
  },
  {
    q: "Do you provide ongoing support?",
    a: "Yes—maintenance SLAs, training, and growth retainers are available.",
  },
  {
    q: "Can you migrate us to your hosting?",
    a: "We plan migrations with zero-downtime windows and full rollback.",
  },
  {
    q: "What industries do you serve?",
    a: "SaaS, e‑commerce, finance, health, education, and emerging tech.",
  },
];